import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { apiGetSettings } from 'src/modules/Collections/redux/Collections.service';
import { addToast } from 'src/components/Toast/redux/Toast.service';
import { TOAST_TYPES } from 'src/components/Toast/redux/Toast.action';
import { ReactComponent as GreenStartSvg } from 'src/assets/svg/home/green-start.svg';
import { format } from 'src/utils';
import { Wrapper } from './Banner.styled';
import { getTotalBalanceLocked, getUniqueKYCs } from '../redux/Home.service';

export default function Banner() {
    const [lockedNumber, setLockedNumber] = useState(0);
    const [uniqueKYCs, setUniqueKYCs] = useState(0);
    const dispatch = useDispatch();

    const getLockTierContract = async () => {
        try {
            const result: any = await apiGetSettings('locked_tier_contract_address');
            const totalUnique = await getUniqueKYCs();
            setUniqueKYCs(totalUnique);
            if (!result) {
                dispatch(
                    addToast({
                        type: TOAST_TYPES.ERROR,
                        title: 'Ops!',
                        description: 'cannot read contract locked tier',
                    }),
                );
                return '';
            }
            return result.Data;
        } catch (error: any) {
            console.error('error: ', error);
        }
    };
    const getLockedIla = async () => {
        try {
            const contract: any = await getLockTierContract();
            const data = await getTotalBalanceLocked(contract);
            setLockedNumber((data as any) / 10 ** 6);
        } catch (error: any) {
            console.log('error: ', error);
        }
    };
    useEffect(() => {
        getLockedIla();
    }, []);
    return (
        <Wrapper>
            <div className="box-banner">
                <div className="item-banner">
                    <span className="fw-regular fs-regular">Up to </span>
                    <span className="percent fs-verylarge fw-suppermedium">40%</span>
                    <div className="hint-banner fw-regular fs-small">Deflationary Staking APY</div>
                </div>
                <div>
                    <GreenStartSvg />
                </div>
                <div className="item-banner">
                    <div className="text-banner fs-verylarge fw-suppermedium">
                        {lockedNumber
                            ? format
                                  .toFixed({
                                      number: lockedNumber,
                                      decimals: 2,
                                  })
                                  .toLocaleString()
                            : '...'}
                        M
                    </div>
                    <div className="hint-banner fs-small fw-regular">ILA Token Locked</div>
                </div>
                <div>
                    <GreenStartSvg />
                </div>
                <div className="item-banner">
                    <div className="text-banner fs-verylarge fw-suppermedium">
                        {uniqueKYCs ? uniqueKYCs.toLocaleString() : '...'}
                    </div>
                    <div className="hint-banner fs-small fw-regular">Unique member KYCs</div>
                </div>
            </div>
        </Wrapper>
    );
}
